import t from "../../../utilities/tw.js";
const r = {
  container: t`box-border flex grow justify-between rounded bg-neutral py-3 shadow-md @md:justify-around @md:py-4`,
  step: t`flex h-fit flex-col items-center gap-2 text-center first:pl-2 last:pr-2 @md:first:pl-0 @md:last:pr-0`,
  label: t`text-caption-xs`
};
export {
  r as progressBarStyles
};
